// Global shim for environment variable compatibility with Vite
// This provides a process.env object for libraries that expect it

import { processEnv } from './env';

// @ts-ignore - We're intentionally creating a global
globalThis.process = globalThis.process || {};
// @ts-ignore - Add NODE_ENV explicitly
globalThis.process.env = new Proxy(processEnv, {
  get(target, prop: string) {
    // Handle NODE_ENV specifically
    if (prop === 'NODE_ENV') {
      return import.meta.env.MODE === 'production' ? 'production' : 'development';
    }
    return target[prop];
  }
});
